import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { TextInput } from '../utils/forms/TextInput';
import { Button } from '../utils/forms/Button';
import { Submit } from '../Formik/Submit';
import PropTypes from 'prop-types';

function ParkingLotForm({ handleCancel, initialValues, handleSubmit }) {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Název parkoviště je povinný'),
    lat: Yup.string().required('Zeměpisná šířka je povinná'),
    lng: Yup.string().required('Zeměpisná délka je povinná'),
    city: Yup.string().required('Město je povinné'),
    street: Yup.string().required('Ulice je povinná')
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      handleCancel={handleCancel}
      validationSchema={validationSchema}
      enableReinitialize
    >
      <Form>
        <div className="clearfix">
          <div>
            <Field name="name" label="Název" component={TextInput} />
          </div>
        </div>
        <div className="clearfix mxn1 mt2">
          <div className="sm-col sm-col-6 px1">
            <Field name="lat" label="Zeměpisná šířka" component={TextInput} />
          </div>
          <div className="sm-col sm-col-6 px1">
            <Field name="lng" label="Zeměpisná délka" component={TextInput} />
          </div>
        </div>
        <div className="mt2">
          <Field name="city" label="Město" component={TextInput} />
        </div>
        <div className="mt2">
          <Field name="street" label="Ulice" component={TextInput} />
        </div>
        <div className="center mt2 mxn1">
          <span className="mr1">
            <Button type="button" color="secondary" onClick={handleCancel}>
              Zrušit
            </Button>
          </span>
          <span className="ml1">
            <Submit value={initialValues.name === '' ? 'Přidat' : 'Upravit'} />
          </span>
        </div>
      </Form>
    </Formik>
  );
}

ParkingLotForm.propTypes = {
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    lat: PropTypes.string,
    lng: PropTypes.string,
    city: PropTypes.string,
    street: PropTypes.string
  })
};

ParkingLotForm.defaultProps = {
  initialValues: {
    name: '',
    lat: '',
    lng: '',
    city: '',
    street: ''
  }
};

export default ParkingLotForm;
